import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import { DATE_FORMAT } from 'constants/config';
import { US_PUBLIC_HOLIDAYS, NONE } from 'constants/schedule';

const styles = () => ({
  root: {
    display: 'flex',
  },
  header: {
    fontWeight: '500',
    fontSize: '15px',
  },
  excludedDates: {
    fontSize: '15px',
  },
});

const ScheduleListItemExcludedDates = ({ schedule, classes }) => {
  const buildExcludedDates = () => {
    const excludedDatesFormated = [];
    if (schedule.exclude_us_holidays) {
      excludedDatesFormated.push(US_PUBLIC_HOLIDAYS);
    }
    if (!isEmpty(schedule.excluded_dates)) {
      excludedDatesFormated.push(...schedule.excluded_dates
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .map(el =>
          moment(el.date)
            .local()
            .format(DATE_FORMAT)));
    }

    if (isEmpty(excludedDatesFormated)) {
      excludedDatesFormated.push(NONE);
    }

    return excludedDatesFormated;
  };
  return (
    <div className={classes.root}>
      <Typography className={classes.header}>Excluding:&nbsp;</Typography>
      <Typography className={classes.excludedDates}>
        {buildExcludedDates(schedule).join('; ')}
      </Typography>
    </div>
  );
};

ScheduleListItemExcludedDates.propTypes = {
  schedule: PropTypes.shape({
    exclude_us_holidays: PropTypes.bool,
    excluded_dates: PropTypes.array,
  }).isRequired,
  classes: PropTypes.element.isRequired,
};

export default withStyles(styles)(ScheduleListItemExcludedDates);
